import React, { useState, useEffect, useRef } from 'react';

const SearchableDropdown = ({ options, value, onChange, placeholder, isDisabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOption = options.find((option) => option.value === value);

  const filteredOptions = options.filter(
    (option) =>
      option.label &&
      typeof option.label === 'string' &&
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
      <div
        onClick={() => !isDisabled && setIsOpen(!isOpen)}
        style={{
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          fontSize: 14,
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: isDisabled ? '#f8fafc' : 'transparent',
          pointerEvents: isDisabled ? 'none' : 'auto',
          transition: 'all 0.2s ease',
          color: selectedOption ? '#1f2937' : '#9ca3af',
          minHeight: '20px'
        }}
        onMouseEnter={e => {
          if (!isDisabled) {
            e.currentTarget.style.backgroundColor = '#f8fafc';
          }
        }}
        onMouseLeave={e => {
          if (!isDisabled) {
            e.currentTarget.style.backgroundColor = 'transparent';
          }
        }}
      >
        <span style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <span style={{
          marginLeft: 8,
          fontSize: 16,
          color: '#6b7280',
          transform: isOpen && !isDisabled ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease'
        }}>
          ▼
        </span>
      </div>
      {isOpen && !isDisabled && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            right: 0,
            backgroundColor: '#ffffff',
            border: '2px solid #e5e7eb',
            borderRadius: 8,
            maxHeight: '240px',
            overflowY: 'auto',
            zIndex: 1000,
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)'
          }}
        >
          <input
            type="text"
            placeholder="Search options..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              borderBottom: '1px solid #e5e7eb',
              fontSize: 14,
              outline: 'none',
              boxSizing: 'border-box',
              backgroundColor: '#f8fafc',
              borderRadius: '8px 8px 0 0'
            }}
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                  setSearchTerm('');
                }}
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',
                  fontSize: 14,
                  backgroundColor: option.value === value ? '#667eea' : '#ffffff',
                  color: option.value === value ? '#ffffff' : '#374151',
                  transition: 'all 0.2s ease',
                  borderBottom: '1px solid #f1f5f9'
                }}
                onMouseEnter={(e) => {
                  if (option.value !== value) {
                    e.currentTarget.style.backgroundColor = '#f1f5f9';
                    e.currentTarget.style.color = '#1e293b';
                  }
                }}
                onMouseLeave={(e) => {
                  if (option.value !== value) {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#374151';
                  }
                }}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div style={{
              padding: '16px',
              fontSize: 14,
              color: '#9ca3af',
              textAlign: 'center',
              fontStyle: 'italic'
            }}>
              No options found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;